export default "__VITE_ASSET__Bdm2mpL___"